import React from "react";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import { Modal, Button } from "antd";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { SummaryPdf } from "./SummaryPdf";

const SummaryModal = (props) => {
  return (
    <Modal
      title="PDF"
      visible={props.shouldOpenPdfModal}
      onCancel={() => props.setShouldOpenPdfModal(false)}
      footer={[
        <PDFDownloadLink document={<SummaryPdf />} fileName="icd_calculator_summary.pdf">
          {({ loading }) => (loading ? <Button disabled={true}>Creating PDF..</Button> : <Button>Download</Button>)}
        </PDFDownloadLink>,
        <Button key="back" onClick={() => props.setShouldOpenPdfModal(false)}>
          Cancel
        </Button>,
      ]}
    >
      <p>This will provide you with a PDF summary.</p>
      <p>
        However if you need to save the data entered so you won't have to enter them again later, please select
        'Download Data' from the menu.
      </p>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    shouldOpenPdfModal: state.status.shouldOpenPdfModal,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setShouldOpenPdfModal: (v) => dispatch(actions.setShouldOpenPdfModal(v)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SummaryModal);
